module.exports = __webpack_public_path__ + "img/profile_settings_icon.950db126.svg";